module.exports = __webpack_public_path__ + "static/img/DZ.0aacb2d4.jpg";